import { $elParent } from './../../utils/utils'
import { BaseComponent } from '../base-component'
import { isEnterKey } from '../../utils/key'
import { CarouselComponent, CarouselDots } from '.'

const CAROUSEL_COMPONENT_SELECTOR = 'carousel-component'
const CAROUSEL_DOTS_SELECTOR = 'carousel-dots'
const HIDE_INSIDE_DOTS_SELECTOR = 'data-hide-inside-dots'

export class CarouselButton extends BaseComponent {
  snaps: number[] = []

  mountComponent(): void {
    this.snaps = [...Array(this.carousel.embla.slideNodes().length).keys()]

    if (this.hasAttribute(HIDE_INSIDE_DOTS_SELECTOR)) {
      this.checkIfToHideButton()
    } else {
      this.initButton()
    }
  }

  unmountComponent(): void {
    if (this.carousel) {
      this.carousel.embla.off('reInit', this.handleCarouselReInit)
      this.carousel.embla.off('scroll', this.handleCarouselScroll)
      this.carousel.embla.off('select', this.handleCarouselSelect)
    }
  }

  checkIfToHideButton = () => {
    const dots: CarouselDots = $elParent(CAROUSEL_DOTS_SELECTOR, this)
    const slidesInView = dots.embla.slidesInView()

    if (slidesInView.length === this.snaps.length) {
      this.hideButton(true)
    } else {
      this.initButton()
    }
  }

  initButton = () => {
    this.update()
    this.addListener(this, 'keydown', this.handleKeyDown)
    this.addListener(this, 'click', this.handleButtonClick)

    if (this.carousel) {
      this.carousel.embla.on('reInit', this.handleCarouselReInit)
      this.carousel.embla.on('select', this.handleCarouselSelect)
      this.carousel.embla.on('scroll', this.handleCarouselScroll)
    }
  }

  handleButtonClick = (event: MouseEvent): void => {
    event.preventDefault()
    this.trigger()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    if (isEnterKey(event)) {
      event.preventDefault()
      this.trigger()
    }
  }

  handleCarouselReInit = (): void => {
    this.update()
  }

  handleCarouselSelect = (): void => {
    this.update()
  }

  handleCarouselScroll = (): void => {
    this.update()
  }

  update(): void {
    this.updateDisable()
    this.updateVisible()
  }

  updateDisable = (): void => {
    const canScroll =
      this.dataset.direction === 'next'
        ? this.carousel?.embla.canScrollNext()
        : this.carousel?.embla.canScrollPrev()

    this.toggleAttribute('disabled', !canScroll)
  }

  updateVisible(): void {
    if (!this.carousel) {
      return
    }

    const slides = this.carousel.embla.slidesInView()

    const index = this.dataset.direction === 'next' ? this.snaps.length - 1 : 0

    this.hideButton(slides.includes(index))
  }

  hideButton = (boolean: boolean) => {
    this.toggleAttribute('has-not-slides-not-in-view', boolean)
  }

  trigger(): void {
    if (this.dataset.direction === 'next') {
      this.carousel?.embla.scrollNext()
    } else {
      this.carousel?.embla.scrollPrev()
    }

    this.carousel?.stop()
  }

  get carousel(): CarouselComponent {
    const carousel: CarouselComponent = $elParent(
      CAROUSEL_COMPONENT_SELECTOR,
      this,
    )

    return carousel
  }
}
